export default __webpack_public_path__ + "static/media/maure_de_bretagne15.e948c8d9.jpg";